import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production', // в production должно быть отключено https://vuex.vuejs.org/ru/guide/strict.html

  state: {
    appTitle: ''
  },

  mutations: {
    appTitle_set (state, title) {
      state.appTitle = title
    }
  },

  actions: {
    setAppTitle ({ commit }, title) {
      commit('appTitle_set', title)
    }
  },

  modules: {
    auth
  }
})
